import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';

@Injectable()
export class StylingService {
  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  public setBrandCSS(brand: string) {
    const _window = window;
    let finalPathNameForCss = '';
    switch (_window.gm.bml.brand) {
      case 'chevrolet':
        finalPathNameForCss = 'chevy';
        break;
      case 'cadillac':
        finalPathNameForCss = 'cadillac-2022';
        break;
      default:
        finalPathNameForCss = _window.gm.bml.brand;
    }
    const cssElement = this.document.getElementById('gbds_css') as HTMLLinkElement;
    cssElement.setAttribute('href', `https://brands.gm-cdn.com/gbds/4.0.20/css/${finalPathNameForCss}.css`);
  }
}
